import { useMutation } from "@tanstack/react-query";
import { useOspApiClientProvider } from "@hooks/useOspApiClientProvider";
import { mergeAdjustAdidIntoHeaders } from "@/src/lib/bridge/adjustRequestHeaders";

interface SendAuthCodeVariables {
  email: string;
}

export const useSendAuthCode = () => {
  const { memberApi } = useOspApiClientProvider();

  return useMutation<void, any, SendAuthCodeVariables>({
    mutationFn: async ({ email }) => {
      if (!memberApi?.auth?.sendCode) {
        throw new Error("memberApi.auth.sendCode is not available");
      }
      try {
        await memberApi.auth.sendCode(
          {
            type: "EMAIL",
            email,
          },
          {
            headers: mergeAdjustAdidIntoHeaders({}),
          },
        );
      } catch (error) {
        // error 是 Response, 需要从 response 中获取 code 和 msg
        if (error instanceof Response) {
          const data = await error.json(); // { code, msg, ... }
          // 统一格式：INDEX_ERROR:<json>，例如 INDEX_ERROR: {"code":106039,"msg":"INVALID_CODE"}
          const payload = JSON.stringify({
            code: data.code,
            msg: data.msg,
          });
          throw new Error(`INDEX_ERROR:${payload}`);
        }
        throw error;
      }
    },
  });
};
